export const PAGES = {
    ADD_WIDGET: "add-widget",
    SELECT_ALL: "select-all",
    SELECT_CUSTOMER_GROUP: "select-customer-group",
    WIDGET_URL: "widget-url",
    WIDGET_TITLE: "widget-title",
    WIDGET_WIDTH: "widget-width",
    WIDGET_SAVE: "widget-save",
    WIDGET_CANCEL: "widget-cancel",
    CREATE_NEW: "create-new",
    DIALOG_NAME: "dialog-name",
    DIALOG_DESCRIPTION: "dialog-desciption",
    DIALOG_UPDATE: "dialog-update",
    DIALOG_CANCEL: "dialog-cancel",
    PAGES_MANAGER: "pages-manager",
    DELETE_PAGE: "delete-page",
    HOME_ROW_BTN: "home-row-btn",
    LINESHEET_ROW_BTN: "linesheet-row-btn",
    EDIT_ROW_BTN: "edit-row-btn",
    DELETE_ROW_BTN: "delete-row-btn",
    DIALOG_CANCEL_DELETE: "dialog-cancel-delete",
    DIALOG_CONFIRM_DELETE: "dialog-confirm-delete",
    HOMEPAGE_TOGGLE: "homepage-toggle",
    FULL_WIDTH_TOGGLE: "full-width-toggle",
    EDIT_TOGGLE: "edit-toggle",
    DASHBOARD_HEADER: "dashboard-header",
    LINESHEET_HEADER: "linesheet-header",
    PAGE_NAME: "page-name",
    PAGE_DESCRIPTION: "page-description",
    PAGE_ROW: "page-row",
    COPY_ROW_BTN: "copy-row-btn",
    SHOW_LINESHEETS_TOGGLE: "show-linesheets-toggle",
    MORE_ACTIONS_BUTTON: "more-actions-button",
    COPY_PAGE: "copy-page",
    WIDGET_GROUPS_TAB: "widget-groups-tab",
    WIDGETS_TAB: "widgets-tab",
    SELECT_LINESHEET: "select-linesheet",
    ORDERS: "orders",
    ORDER_DETAILS: "order-details",
};
